module.exports = __webpack_public_path__ + "img/icons-24-setting-active.cba432f5.svg";